const IconButton = {
  baseStyle: {
    background: "transparent",
    _hover: {
      background: "transparent",
      boxShadow: "none"
    },
    _focus: {
      background: "transparent",
      boxShadow: "none"
    }
  }
};

export default IconButton;
